export default __webpack_public_path__ + "9e11d96f00fc5e688c38781cbb43ea66.svg";